import React, { Component } from 'react';

export default class DropdownContent extends Component {
  constructor(props) {
    super(props);
    this.state = {isOpen: false};
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }
  render() {
    return (
    <div className={this.state.isOpen ? 'dropdown-content open' : 'dropdown-content closed'}>
      <a onClick={this.handleClick} className={'header'}>{this.props.header}</a>
      <div className={'body'} dangerouslySetInnerHTML={{ __html:this.props.body }}/>
    </div>
    );
  }

};






// WEBPACK FOOTER //
// ./src/components/dom-elements/DropdownContent.js